<template>
  <div class="n-input" :class="{ 'has-error': errorMessage }">
    <fieldset :id="id" :name="name" class="checkbox-group">
      <legend :class="{ 'sr-only': hideLabel }">{{ label }}</legend>
      <div class="checkbox-group__checkboxes">
        <slot></slot>
      </div>
    </fieldset>
    <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'n-checkbox-group',
});

defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  errorMessage: {
    type: String,
    required: true,
  },
  hideLabel: {
    type: Boolean,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
@use '../../../styles/accessibility' as *;
@use '../../../styles/colours' as *;
@use '../../../styles/input' as *;
.checkbox-group {
  border: none;
  padding: 0;
  legend {
    margin-bottom: 1rem;
  }
  &__checkboxes {
    .checkbox {
      margin-bottom: 0.5rem;
    }
    input[type='checkbox'] {
      display: inline-block;
      padding: 0;
      border: none;
      box-shadow: none;
      width: auto;
    }
    label {
      display: flex;
      cursor: pointer;
      justify-content: flex-start;
    }
  }
}
</style>
